import { useGlobalSearchParams } from "expo-router";
import { useMemo } from "react";
import { JournalForm } from "~/components/form/journal/JournalForm";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useJournal } from "~/providers/JournalProvider";
import { useTrackable } from "~/providers/TrackableProvider";

export default function EditJournal() {
    const { id }: { id: string } = useGlobalSearchParams();
    const { handleDismiss } = useDismiss();
    const { findJournal, canUpdateJournal } = useJournal();
    const { findTrackable } = useTrackable();

    const journal = useMemo(() => findJournal(id), [id, findJournal]);
    const trackable = findTrackable(journal?.trackable_id);

    if (!journal || !trackable || !canUpdateJournal(trackable.type)) {
        return <Dismiss />;
    }

    return <JournalForm onRequestClose={handleDismiss} journal={journal} asRoute />;
}
